import { NavbarStyle } from "./style";

export const NavbarComponent = (props) => (
    <NavbarStyle>
        {props.children}
    </NavbarStyle>
)